import { MetadataAction } from '@common/types/action';
import { ActionResponse } from '../excuteAction';
import { Platform } from 'react-native';
import { ActionStatus } from '@common/constants/shared';

export const executeEkyc = async (
  action: Record<string, any>,
  _metadata: MetadataAction
): Promise<ActionResponse> => {
  try {
    const { response } = action;
    const { isAlreadyVerified, success, ekycEntryUrl } = response || {};

    if (isAlreadyVerified) {
      return {
        status: ActionStatus.SUCCESS,
      };
    }

    if (!success || !ekycEntryUrl)
      throw new Error('Failed to start eKYC verification');

    if (window.top && Platform.OS === 'web') {
      window.top.location.href = ekycEntryUrl;
      //NOTE: this should stop the process, no actions after this point will be executed
    } else {
      throw new Error('Ekyc is not supported on this platform');
    }

    return {
      status: ActionStatus.SUCCESS,
    };
  } catch (error: any) {
    return {
      status: ActionStatus.FAILED,
      message: `Failed to initiate eKYC verification: ${
        error.message || 'Unknown error'
      }`,
    };
  }
};
